export class SearchController {
  constructor(controller) {
    this.controller = controller;
  }

  // ========================================
  // 検索処理
  // ========================================

  onSearchClick(event) {
    event.preventDefault();

    const prefectureId = this.controller.selectedPrefectureId;
    const cityId = this.controller.selectedCity;

    // 都道府県が選択されていない場合はエラー
    if (!prefectureId) {
      alert('都道府県を選択してください');
      return;
    }

    // 補助金エリアページへ遷移
    // 市区町村が選択されている場合: /subsidies/area/:prefecture_id/:city_id
    // 都道府県のみの場合: /subsidies/area/:prefecture_id
    const url = cityId
      ? `/subsidies/area/${prefectureId}/${cityId}`
      : `/subsidies/area/${prefectureId}`;

    // ページ遷移
    window.location.href = url;
  }
}
